/**
 * The metrics shared by the controls that sit in a chart's header row.
 *
 * In one place because they are what makes the row line up: two buttons side
 * by side with different padding or font size are different heights, and a
 * flex row then centres them against each other at a visible offset. Keeping
 * the numbers here means changing one control cannot silently knock the row
 * out of alignment.
 */
export const CONTROL_BUTTON: React.CSSProperties = {
  padding: "6px 12px",
  fontSize: 13,
  letterSpacing: "0.1em",
  cursor: "pointer",
};

/**
 * The row itself. Spacing lives here rather than on any one control, because
 * a margin on a child is part of its margin box and flex alignment centres
 * the margin box, not the border box -- which is exactly how the export
 * button ended up sitting lower than the range picker beside it.
 */
export const CONTROL_ROW: React.CSSProperties = {
  display: "flex",
  gap: 16,
  alignItems: "center",
  marginBottom: 16,
};
